import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { INSTITUTION_CONTEXT_TOKEN } from 'aa-ng';
import { map, Observable } from 'rxjs';
import { IInstitutionContext } from 'src/app/models';

import { IResultSet } from '../models';
import {
  IPersonSearchQueryAndFilters,
  IPersonSearchResult,
} from '../models/person-search';

@Injectable({ providedIn: 'root' })
export class PersonSearchService {
  private http = inject(HttpClient);
  private institutionContext = inject<IInstitutionContext>(
    INSTITUTION_CONTEXT_TOKEN,
  );

  private _baseUrl = '/api/person-search';

  search(
    searchQueryAndFilters: IPersonSearchQueryAndFilters,
  ): Observable<IResultSet<IPersonSearchResult[]>> {
    searchQueryAndFilters.filters.institutionIds =
      searchQueryAndFilters.query.queryCriteria.includedInstitutionIds;

    const params = {
      ...searchQueryAndFilters,
      query: {
        ...searchQueryAndFilters.query,
        queryCriteria: {
          query: searchQueryAndFilters.query.queryCriteria.query,
          searchType: searchQueryAndFilters.query.queryCriteria.type,
        },
      },
    };

    return this.http
      .post<
        IResultSet<IPersonSearchResult[]>
      >(`${this._baseUrl}/search`, params)
      .pipe(
        map((resultSet) => {
          const unitAffiliationTypesHidden = new Set(
            this.institutionContext.unitAffiliationTypesHidden || [],
          );

          if (this.institutionContext.unitAffiliationTypesHidden?.length) {
            resultSet.results.forEach((person) => {
              if (
                person.primaryUnitAffiliation &&
                unitAffiliationTypesHidden.has(
                  person.primaryUnitAffiliation.type,
                )
              ) {
                person.primaryUnitAffiliation = null;
              }
            });
          }
          return resultSet;
        }),
      );
  }
}
